import { Alert } from '@forge/common'
import { ApiUserFieldsFragment } from '@forge/graphql/generated'
import { ExclamationCircleIcon } from '@heroicons/react/outline'
import { useDeleteApiUser } from './useDeleteApiUser'

interface DeleteApiUserProps {
  apiUser: ApiUserFieldsFragment
  isOpen: boolean
  onClose: () => void
}

export function DeleteApiUser(props: DeleteApiUserProps) {
  const { apiUser, isOpen, onClose } = props

  const {
    mutate: deleteApiUser,
    isLoading: isDestroying,
    error
  } = useDeleteApiUser()

  return (
    <Alert variant="danger" isOpen={isOpen}>
      <Alert.Title>Delete API User</Alert.Title>
      <Alert.Content>
        <div className="space-y-2">
          <div>
            Are you sure you want to delete this user (
            <strong className="font-medium text-gray-700">
              {apiUser.name}
            </strong>
            )? This action cannot be undone.
          </div>
          {error && (
            <div className="text-red-500" role="alert" aria-live="polite">
              {error.message}
            </div>
          )}
        </div>
      </Alert.Content>
      <Alert.Cancel onClick={onClose}>Cancel</Alert.Cancel>
      <Alert.Confirm
        leftIcon={<ExclamationCircleIcon />}
        loading={isDestroying}
        onClick={() => {
          deleteApiUser(
            { id: apiUser.id },
            {
              onSuccess() {
                onClose()
              }
            }
          )
        }}>
        Delete Forever
      </Alert.Confirm>
    </Alert>
  )
}
